import { useTranslation } from 'react-i18next';

import { bibleLanguages } from '../../../constants/bibleLanguage';
import './BibleLanguagesGroup.module.css';

export const BibleLanguagesGroup = () => {
  const { t } = useTranslation();
  return (
    <div className="languageGrid">
      {bibleLanguages.map((lang) => (
        <div key={lang.code} className="languageCard">
          <img className="icon" src={lang.imageSrc} />
          <div className="languageDetails">
            <p className="languageCode">{lang.code}</p>
            <p className="languageName">{t(lang.name)}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
